export function ThumbsUp(props: any) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "80%",
        height: "80%",
        minHeight: "70px",
      }}
    >
      <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
      >
        {/* Background circle */}
        <rect width="70" height="70" rx="50" fill="#D1FADF" />

        {/* Thumbs up icon centered */}
        <g transform="translate(21 15)">
          <path
            d="M7 28V18M1 20.3333V25.6667C1 26.4031 1.59695 27 2.33333 27H6.48969C6.77435 27 7.05178 27.0878 7.28531 27.2519L10.8896 29.7724C11.695 30.3261 12.6654 30.6262 13.6594 30.6316L18.9999 30.6528C20.5276 30.6611 21.847 29.517 22.0664 28.0091L23.2867 19.6758C23.5574 17.8461 22.1581 16.2 20.3076 16.2H16.3C15.5163 16.2 14.9333 15.4832 15.1305 14.7232L16.5199 9.26635C16.7595 8.34635 16.2904 7.38635 15.4204 6.93168C14.0704 6.22168 12.3871 6.77835 11.7304 8.15168L7.4971 17.4384C7.17643 18.1617 6.47176 18.6334 5.68843 18.6334H2.33333C1.59695 18.6334 1 19.2303 1 19.9667V20.3333Z"
            stroke="#047857"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </div>
  );
}
